module.exports = __webpack_public_path__ + "img/v2-cart-bowl.426fc06e.svg";